import { isNil } from 'lodash';
import * as productGroupService from 'services/productGroupService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRProductGroupsData = Awaited<
  ReturnType<typeof productGroupService.getProductsGroupsAsync>
>;

const useProductGroups = (load = true): SWRResponse<SWRProductGroupsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_PRODUCT_GROUPS_ENDPOINT] : null,
    async () => await productGroupService.getProductsGroupsAsync()
  );

export const SWR_PRODUCT_GROUPS_ENDPOINT = 'product-groups';
export default useProductGroups;
